import { Component, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { AdminService } from "../../admin.service";
import { MatDialog } from "@angular/material/dialog";
import { UploadDocumentComponent } from "../upload-document/upload-document.component";

@Component({
    selector: 'app-view-order',
    templateUrl: './view-order.component.html',
    styleUrls: ['./view-order.component.scss']
  })
  
export class ProcureViewOrderComponent implements OnInit {

    public quoteForm: FormGroup;
    public moment: any;
    public loginName: string;
    public loginUserId: string;
    public addresses: any;
    public quoteId: number;
    public orderDetails: any;
  resData: any;

    constructor(
        private activatedRoute: ActivatedRoute,
        private fb: FormBuilder, 
        public adminService: AdminService, 
        private toastr: ToastrService,
        public router: Router,
        private dialog: MatDialog,
    ){

    }

    ngOnInit(): void {
        this.quoteId = parseInt(this.activatedRoute.snapshot.paramMap.get('id'));

        this.moment = moment;
        this.loginName = localStorage.getItem('name');
        this.loginUserId = localStorage.getItem('id');
        this.getProfileDetails();
        this.getQuoteForm();
        this.getQuoteDetails(this.quoteId);
    }

    public getQuoteForm(): void{
        this.quoteForm = this.fb.group({
            'deliverydate': [null],
            'customerid': [this.loginUserId],
            'shippingaddressid': [null],
            'supplierid': [0],
            "quantity": [0],
            "totalcost": [0],
            "taxes": [0],
            "shipingcost": [10],
            "paymentmethodid": [0],
            "paymentstatusid": [0],
            "currencytypeid": [1],
            "contactperson": ["10"],
            "shipmenttermsid": [41],
            "paymenttermsid": [42],
            "loanid": [0],
            "insertype": ["23"],
            "salesrepid": [0],
            'materialsItems': this.fb.array([])
        });
        
        this.addItemsArray();
    }

    public addItemsArray(){
        (this.quoteForm.get('materialsItems') as FormArray).push(this.fb.group({
            "id": [null],
            "materialtypeid": [null],
            "mategrialdescription": [null],
            "quantity": [null],
            "targetdate": [null],
            "itemcost": [null],
            "priceperkg": [null]
          }));
    }

    

    getQuoteDetails(id): void{
        this.adminService.getQuoteDetails(id).subscribe(
            (res: any) => {
                const data = res.body.data;
                this.orderDetails = res.body.data;
                this.quoteForm.patchValue(data);         
            },
            err => {
               console.log(err);
            }
          );
    }

   
    getProfileDetails(): void {
        this.adminService.getUserProfileDetails().subscribe(
          (res: any) => {
            this.addresses = res.addresses;
          },
          err => {
             console.log(err);
          }
        );
    }

    orderComplete(){
        this.adminService.completeOrder(this.quoteId).subscribe(
            (res: any) => {
              if (res?.body?.status == 'success') {
                this.toastr.success('Order was completed successfully');
              } else {
                this.toastr.error('Update Failed');
              }
            },
            err => {
              console.log(err);
            }
          );
    }

    getLoan(){
        this.adminService.loan({'data':this.quoteId}).subscribe(
            (res: any) => {
                if (res?.status == 'success') {
                    this.resData = res?.data;
                    console.log(this.resData)
                    const dialogRef = this.dialog.open(UploadDocumentComponent,
                        {
                          panelClass: 'my-panel',
                          disableClose: true,
                          data: { data: this.resData }
                        });
                  
                      dialogRef.afterClosed().subscribe(
                        res => {
                          
                        }
                      )
                  } else {
                    this.toastr.error('Update Failed');
                  }
            }
        )
    }

}